<template>
    <div class="example">
        <el-button
            type="text"
            @click="visible = true"
        >
            查看示例
        </el-button>
        <el-dialog
            title="查看示例"
            :visible.sync="visible"
            width="380px"
        >
            <div
                v-for="(item, idx) in data"
                :key="idx"
            >
                <div
                    class="text-info"
                >
                    {{ item.desc }}
                    <div v-if="!item.desc">
                        示例一：商品外箱有规格（净含量），如图所示，外箱净含量为500ml*3罐*4组，可区分不同情况进行填写<br />
                        <span>1、若以“单罐"形式售卖，则箱规填写12</span>     <br />
                        <span>2、若以“三连包"形式售卖，则箱规填写4 </span>      <br />
                        <span>3、若以"整箱"形式售卖，则箱规填写1</span>
                    </div>
                </div>
                <el-carousel
                    v-if="item.pics.length"
                    class="example-pic"
                    :autoplay="false"
                    :arrow="item.pics.length > 1 ? 'always' : 'never'"
                >
                    <el-carousel-item
                        v-for="(pic, i) in item.pics"
                        :key="i"
                    >
                        <xn-upload
                            :value="pic"
                            list-type="picture-card"
                            accept="image/jpeg, image/png, image/jpg"
                            disabled
                            in-dialog
                        />
                    </el-carousel-item>
                </el-carousel>
            </div>
            <span
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    type="primary"
                    size="mini"
                    @click="visible = false"
                >我知道了</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const example = [
    {
        desc: '',
        pics: ['https://p0.meituan.net/mallimages/e54100bc87c2606143930e44f06f2c66161095.png'],
    },
    {
        desc: '示例二：用周转框送货的商品，框中可存放多少商品，则箱规填写多少',
        pics: ['https://p0.meituan.net/mallimages/17a04cf2150e1457a3c8b55e5a273128718750.jpg'],
    },
    {
        desc: '示例三：活鲜商品（活鱼、活虾等）、无包装无标签的原料，则箱规填写1',
        pics: [],
    },
];

export default {
    data() {
        return {
            visible: false,
        };
    },
    computed: {
        data() {
            return example;
        },
    },
};
</script>

<style lang='scss' scoped>
.example{
    display: inline-block;
}
::v-deep .example-pic {
    .xx-upload.is-disabled .el-upload--picture-card {
        display: none;
    }
    .el-upload-list--picture-card .el-upload-list__item {
        width: 100%;
        height: 280px;
    }
}
.text-info {
    line-height: 1.8;
    text-align: left !important;
    white-space: normal;
    font: 14px sans-serif;
}
</style>
